// 12 seed records — mix of all offeringStatus+submissionStatus combos
// offeringStatus is NOT stored here; it is derived in the store from submissionDeadline vs now.
// Deadlines in the past → Closing; deadlines in the future → Opening.

const FUTURE = '2027-12-31T17:00:00+07:00'; // always in the future
const PAST = '2026-06-30T17:00:00+07:00'; // always in the past

const cargo = (id, extras = {}) => ({
  id,
  cargoType: 'Crude',
  ot: 10,
  volume: 500000,
  ddrFrom: '2026-09-01T00:00:00+07:00',
  ddrTo: '2026-09-30T00:00:00+07:00',
  ddrNotes: '',
  incoterms: ['FOB'],
  incotermsNotes: '',
  plant: 'RU II Dumai',
  unit: 'CDU I/II',
  crudes: [
    {
      id: `${id}-c1`,
      crudeName: 'Minas',
      maxCapacity: 80000,
      remarkMaxCapacity: '',
      isViaCibOnly: false,
      bleeding1: 0,
      bleeding2: 0,
    },
    {
      id: `${id}-c2`,
      crudeName: 'Duri',
      maxCapacity: 60000,
      remarkMaxCapacity: 'Max per lifting',
      isViaCibOnly: true,
      bleeding1: 5,
      bleeding2: 3,
    },
  ],
  ...extras,
});

const clause = (id, mandatory = false) => ({
  clauseId: `cls-${id}`,
  title: `Klausul ${id}`,
  mandatory,
  summernote: `<p>Isi klausul nomor ${id} yang wajib dipenuhi oleh DMUT.</p>`,
});

const doc = (id, source = 'Planning') => ({
  id: `doc-${id}`,
  name: `Dokumen ${id}`,
  source,
  showToDmut: true,
  fileName: `document_${id}.pdf`,
  fileContentType: 'application/pdf',
  lastUpdated: '2026-07-01T08:00:00+07:00',
});

const record = (n, submissionDeadline, submissionStatus, extras = {}) => ({
  id: `off-${n}`,
  procId: `CRUDE-2026072026-${String(n).padStart(4, '0')}`,
  title: `Crude Term Q${Math.ceil(n / 3)} 2026 - RU ${['II Dumai', 'III Plaju', 'IV Cilacap', 'V Balikpapan', 'VI Balongan'][n % 5]}`,
  procurementType: 'Crude dan Condensat',
  procurementMethod: 'Pelelangan khusus',
  description: `Pengadaan crude term untuk kebutuhan kilang Q${Math.ceil(n / 3)} tahun 2026. Record #${n}.`,
  submissionDeadline,
  submissionStatus,
  validity: {
    submissionDeadline,
    validityPeriod: submissionDeadline,
  },
  requirement: {
    contractType: n % 2 === 0 ? 'Term' : 'Spot',
    startPeriod: '2026-10-01T00:00:00+07:00',
    endPeriod: '2026-12-31T00:00:00+07:00',
    cargos: [
      cargo(`off-${n}-cg1`),
      cargo(`off-${n}-cg2`, { plant: 'RU IV Cilacap', unit: 'CDU II/III' }),
    ],
    clauses: [clause(1, true), clause(2), clause(3)],
    additionalNotes: n % 3 === 0 ? 'Prioritas pengadaan untuk Q4.' : '',
  },
  supportingDocuments: [
    doc(`${n}-p`, 'Planning'),
    doc(`${n}-pr`, 'Procurement'),
  ],
  ...extras,
});

// Opening + Draft (3 records)
// Opening + Submitted (3 records)
// Closing + Draft (3 records)
// Closing + Submitted (3 records)
export const SEED_OFFERINGS = [
  record(1, FUTURE, 'Draft'),
  record(2, FUTURE, 'Draft'),
  record(3, FUTURE, 'Draft'),
  record(4, FUTURE, 'Submitted'),
  record(5, FUTURE, 'Submitted'),
  record(6, FUTURE, 'Submitted'),
  record(7, PAST, 'Draft'),
  record(8, PAST, 'Draft'),
  record(9, PAST, 'Draft'),
  record(10, PAST, 'Submitted'),
  record(11, PAST, 'Submitted'),
  record(12, PAST, 'Submitted'),
];
